import { signOut } from 'aws-amplify/auth';
import React, { useCallback } from 'react';
import styled from 'styled-components';

import Button from '@material-ui/core/Button/Button';
import Typography from '@material-ui/core/Typography/Typography';

import { useAppState } from '../../../hooks/useAppState';
import { FlexColumn, FlexRow } from '../../GlobalStyled/GlobalStyled';

export const UserInfo: React.FC = () => {
  const [appState] = useAppState();
  const { user } = appState;
  const userRoles = user?.cognitoGroups || [];

  const handleSingOut = useCallback(() => {
    signOut();
  }, []);

  return (
    <Container>
      <UserName title={`User roles: ${userRoles.join(',')}`}>
        <Typography variant="body2" color="textPrimary">
          {user?.attributes?.email}
        </Typography>
      </UserName>
      <Button disableElevation onClick={handleSingOut} href="#" color="primary" size="small">
        <Typography variant="body2" color="inherit">
          Sign Out
        </Typography>
      </Button>
    </Container>
  );
};

const Container = styled(FlexRow)`
  height: 100%;
  align-items: center;

  > div + div {
    margin-left: 1.5rem;
  }
`;

const UserName = styled(FlexColumn)`
  color: ${({ theme }) => theme.colors.brandDarkGrey};
  opacity: 0.8;
  margin-right: 4px;

  @media screen and (max-width: 1024px) {
    display: none;
  }
`;
